<template>
  <div 
    class="h-100 py-2 px-3 bg-sachlich-white border"
  >
    <div 
      v-if="!!matchingCabins.length && !!cabin"  
      class="row h-100"
    >
      <div 
        class="col h-100" 
        :class="displayError ? '' : 'border-right'"
      >
        <div class="row py-2 pe-1">
          <div class="col-2">
            <Icon
              type="left"
              @click="backClicked" 
            />
          </div>
          <div class="col-5 ps-0">
            <DropdownField
              field-name="deckSelect"
              :field-value="selectedDeckId"
              :value-changed="setDeck"
              :item-list="deckItems"
              :disabled="displayError"
            />
          </div>
          <div class="col-5 ps-0">
            <DropdownField
              field-name="cabinSelect"
              :field-value="selectedCabinId"
              :value-changed="setCabin"
              :item-list="cabinItems"
              :disabled="displayError"
            />
          </div>
        </div>
  
        <div class="row h-100 overflow-scroll">
          <div class="col">
            <PageLoader 
              v-if="isCabinLoading" 
              title="Lade Kabinen ..." 
            />
            <ShipCabinsView 
              v-else-if="!!matchingCabins.length"
              :select-cabin="setCabin"
            />
          </div>
        </div>
      </div>
  
      <div class="col">
        <CabinDetails />
      </div>
    </div>
  
    <PageLoader 
      v-if="!isCabinLoading && !matchingCabins.length"
      title="Leider ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut..." 
    />
  </div>
</template>

<script lang="ts">
import { ClickCallback } from '@/components/callbacks'
import Icon from '@/components/common/Icon.vue'
import { IPremiumCabinSelectorItems } from '@/components/interfaces'
import { useCabinStore } from '@/store'
import { sortBy } from 'lodash-es'
import { mapActions, mapState } from 'pinia'
import { PropType, defineComponent } from 'vue'
import DropdownField from '../../common/DropdownField.vue'
import PageLoader from '../../common/PageLoader.vue'
import CabinDetails from './CabinDetails.vue'
import ShipCabinsView from './ShipCabinsView.vue'

export default defineComponent({
  components: { CabinDetails, ShipCabinsView, DropdownField, PageLoader, Icon },

  props: {
    proceedClicked: {
      type: Function,
      default: () => undefined,
    },
    backClicked: {
      type: Function as PropType<ClickCallback>,
      default: () => undefined,
    },
  },

  computed: {
    ...mapState(useCabinStore, {
      decks: store => store.decks,
      category: store => store.category,
      cabin: store => store.cabin,
      deck: store => store.deck,
      isCabinLoading: store => store.isCabinLoading
    }),
    ...mapState(useCabinStore, {
      matchingCabins: store => store.matchingCabins,
    }),

    deckItems(): IPremiumCabinSelectorItems[] {
      if (!this.decks) return []

      return this.decks.map(deck => {
        return {
          key: String(deck.id),
          listDisplay: `Deck ${deck.id}`,
          unavailable: !deck.available,
        }
      })
    },
    cabinItems(): IPremiumCabinSelectorItems[] {
      if (!this.matchingCabins?.length || !this.deck) {
        return []
      }

      const currentCabins = this.matchingCabins.filter(cabin => cabin.deck === this.deck!.id)
      
      const cabinItems: IPremiumCabinSelectorItems[] = currentCabins.map( cabin => {
          return {
            key: String(cabin.id),
            listDisplay: String(cabin.id),
          }
        })

      return sortBy(cabinItems, item => item.key)
    },
    selectedDeckId() {
      return !!this.deck ? String(this.deck.id) : ''
    },
    selectedCabinId() {
      return this.cabin?.id ?? ''
    },

    displayError() {
      return !this.isCabinLoading && (!this.matchingCabins.length || !this.selectedDeckId)
    }
  },
  methods: {
    ...mapActions(useCabinStore, {
      selectCabin: 'selectCabin',
      selectDeck: 'selectDeck'
    }),
    setCabin(_: string, cabinId: string) {
      this.selectCabin(cabinId)
    },
    setDeck(_:string, deckId: string) {
      this.selectDeck(deckId)
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.border-right {
  border-right: 1px solid $color-expinet-gray;
}
</style>
